<template>
  <!------------------------ Tablet Screen -------------------------->
  <!------------------------- Start --------------------------------->
  <v-card :loading="loading" elevation="0" class="px-5" v-if="checkBreakPoints">
    <div class="d-flex mt-5">
      <!-- <v-text-field
        prepend-inner-icon="mdi-magnify"
        outlined
        height="5px"
        placeholder="Search"
        dense
        v-model="search"
        @input="resetSearchOnEmpty"
        class="shrink"
      ></v-text-field>
      <v-btn
        :disabled="search.length < 1"
        color="primary"
        height="40"
        width="40"
        max-width="40"
        outlined
        class="ml-8"
        @click="getTabletActivityLogs"
      >
        <v-icon>mdi-filter-outline</v-icon>
      </v-btn> -->
      <v-spacer></v-spacer>
      <div class="py-1 title">
        {{ from }} - {{ to }} {{$t('of')}} {{ totalReminders }}
      </div>
      <v-btn
        :disabled="tabletTableOptions.page <= 1"
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        @click="tabletPageChange(false)"
      >
        <v-icon dark> mdi-chevron-left </v-icon>
      </v-btn>
      <v-btn
        :disabled="tabletTableOptions.page >= totalPages"
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        @click="tabletPageChange(true)"
      >
        <v-icon dark> mdi-chevron-right </v-icon>
      </v-btn>
    </div>
    <v-card
      v-for="(item, index) in remindersData"
      :key="index"
      class="inner-card my-4 py-2 px-4"
      :elevation="0"
      :style="
        index % 2 !== 0 && {
          backgroundColor: 'rgba(243, 243, 243, 0.5)',
        }
      "
    >
      <v-row no-gutters class="my-5" justify="center" align="center">
        <v-col md="6" class="font-weight-bold">{{$t('taskNumber')}}</v-col>
        <v-col md="6">{{ item.TENumber }}</v-col>
      </v-row>
      <v-row no-gutters class="my-5" justify="center" align="center">
        <v-col md="6" class="font-weight-bold">{{$t('taskName')}}</v-col>
        <v-col md="6">{{ item.name }}</v-col>
      </v-row>
      <v-row no-gutters class="my-5" justify="center" align="center">
        <v-col md="6" class="font-weight-bold">{{$t('startDate')}}</v-col>
        <v-col md="6">{{ item.createdAt }}</v-col>
      </v-row>
      <v-row no-gutters class="my-5" justify="center" align="center">
        <v-col md="6" class="font-weight-bold">{{$t('dueDate')}}</v-col>
        <v-col md="6">{{ item.dueDate }}</v-col>
      </v-row>
      <v-row no-gutters class="my-5" justify="center" align="center">
        <v-col md="6" class="font-weight-bold">{{$t('animal.details')}}</v-col>
        <v-col md="6">
          <v-btn
            target="_blank"
            :to="{
              name: 'SingleDailyTask',
              params: { task_id: item.TENumber },
            }"
            outlined
            color="primary"
            rounded
            small
          >
            {{$t('animal.details')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
  <!--------------------------End ----------------------------------->
  <div v-else>
    <div class="d-flex mb-5">
      <v-text-field
        prepend-inner-icon="mdi-magnify"
        outlined
        :placeholder="$t('animal.searchByTaskNameNumber')"
        dense
        class="shrink"
        v-model="search"
        @input="resetSearchOnEmpty"
      >
      </v-text-field>
      <v-btn
        color="primary"
        height="40"
        width="40"
        max-width="40"
        outlined
        class="ml-8"
        @click="searchData"
        :disabled="search.length < 1"
      >
        <v-icon>mdi-filter-outline</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div class="py-1 title">
        {{ from }} - {{ to }} {{$t('of')}} {{ totalReminders }}
      </div>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="options.page <= 1"
        @click="pageChange(false)"
      >
        <v-icon dark> mdi-chevron-left </v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        fab
        small
        outlined
        color="primary"
        :disabled="options.page >= totalPages"
        @click="pageChange(true)"
      >
        <v-icon dark> mdi-chevron-right </v-icon>
      </v-btn>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        left
        :min-width="417"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark> mdi-cog-outline </v-icon>
          </v-btn>
        </template>

        <v-card width="417">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t("customization")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <div class="pl-3 pt-2 font-weight-normal">
              {{ $t("recordsPerPage") }}
            </div>
            <v-list-item>
              <v-list-item-content>
                <v-slider
                  v-model="itemsPerPageSlider"
                  :tick-labels="itemsPerPageOptions"
                  :max="3"
                  step="1"
                  ticks="always"
                  tick-size="4"
                ></v-slider>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-n3"></v-divider>
          </v-list>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col
                  class="mt-n9"
                  cols="6"
                  v-for="header in headers"
                  :key="header.value"
                >
                  <v-checkbox
                    v-model="selectedHeaders"
                    :label="header.text"
                    color="primary"
                    :value="header.text"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-layout justify-center>
            <v-card-actions class="mb-5">
              <v-spacer></v-spacer>

              <v-btn
                outlined
                color="primary"
                @click="menu = false"
                width="190"
              >
                {{ $t("restoreDefault") }}
              </v-btn>
              <v-btn
                color="primary"
                width="190"
                @click="resetTableStructure"
              >
                {{ $t("apply") }}
              </v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-menu>
    </div>
    <v-data-table
      :headers="tableHeaders"
      :items="remindersData"
      :items-per-page="10"
      hide-default-footer
      :loading="loading"
      :loading-text="$t('loadingData')"
      :options.sync="options"
      :server-items-length="totalReminders"
    >
      <template v-slot:footer></template>
      <template v-slot:[`item.status`]="{ item }">
        <v-btn
          target="_blank"
          :to="{ name: 'SingleDailyTask', params: { task_id: item.TENumber } }"
          outlined
          color="primary"
          rounded
          small
        >
          {{$t('animal.details')}}
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";

export default {
  watch: {
    options: {
      handler() {
        this.getReminders();
      },
      deep: true,
    },
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  created() {
    if (this.checkBreakPoints) this.tabletGetReminders();
  },
  async mounted() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
  },
  data() {
    return {
    totalReminders: 0,
    from: 0,
    to: 0,
    totalPages: 0,
    options: {},
    search: "",
    tabletTableOptions: { itemsPerPage: 5, page: 1, sortBy: [] },
    loading: true,
    remindersData: [],
    headers: [
      {
        text: this.$t('taskNumber'),
        align: "start",
        sortable: false,
        value: "TENumber",
      },
      { text: this.$t('taskName'), value: "name" },
      { text: this.$t('startDate'), value: "startDate" },
      { text: this.$t('dueDate'), value: "dueDate" },
      { text: this.$t('animal.details'), value: "status" },
    ],
    menu: false,
    itemsPerPageSlider: 1,
    itemsPerPageOptions: [5, 10, 25, 50],
    selectedHeaders: [],
    tableHeaders: [],
    oldSelected: [],
    allSelectedHeaders: [
      this.$t('taskNumber'),
      this.$t('taskName'),
      this.$t('startDate'),
      this.$t('dueDate'),
      this.$t('animal.details')
    ],
    noRecordHeader: [
      this.$t('taskNumber'),
      this.$t('taskName'),
      this.$t('startDate'),
      this.$t('dueDate'),
      this.$t('animal.details')
    ],
  }},
  methods: {
    getReminders() {
      this.loading = true;
      AnimalService.getReminders(
        this.options,
        this.$route.params.animal_number,
        this.search
      )
        .then((res) => {
          this.remindersData = res.data.reminder.rows;
          this.totalReminders = res.data.reminder.total_rows;

          if (this.totalReminders < 1) {
            this.oldSelected = this.selectedHeaders;
            this.selectedHeaders = this.noRecordHeader;
          } else {
            if (this.oldSelected.length > 1)
              this.selectedHeaders = this.oldSelected;
            else {
              this.selectedHeaders = this.allSelectedHeaders;
              this.oldSelected = [];
            }
          }

          this.resetTableStructure();

          this.totalPages = Math.ceil(
            this.totalReminders / this.options.itemsPerPage
          );
          this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;
          this.to =
            this.options.page * this.options.itemsPerPage -
            (this.options.itemsPerPage - res.data.reminder.num_rows);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    tabletGetReminders() {
      AnimalService.getReminders(
        this.tabletTableOptions,
        this.$route.params.animal_number,
        this.search
      )
        .then((res) => {
          this.remindersData = res.data.reminder.rows;
          this.totalReminders = res.data.reminder.total_rows;
          this.totalPages = Math.ceil(
            this.totalReminders / this.tabletTableOptions.itemsPerPage
          );
          this.from =
            (this.tabletTableOptions.page - 1) *
              this.tabletTableOptions.itemsPerPage +
            1;
          this.to =
            this.tabletTableOptions.page *
              this.tabletTableOptions.itemsPerPage -
            (this.tabletTableOptions.itemsPerPage - res.data.reminder.num_rows);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;

      this.getReminders();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.tabletGetReminders();
    },
    resetSearchOnEmpty() {
      // if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getReminders();
      } else {
        this.options.page = 1;
        this.tabletGetReminders();
      }
    },
    searchData() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.tabletGetReminders();
      } else {
        this.options.page = 1;
        this.getReminders();
      }
    },
    resetTableStructure() {
      // this.startLoading();
      this.loading = true;
      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.options.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      // this.stopLoading();
      this.loading = false;
    },
  },
};
</script>